import { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import backBtn from "../assets/icons/arrow_left.svg";
import { useUser } from "../contexts/UserContext";
import moment from "moment";


interface LoggedInAdminDataProps {
	onHide: () => void
}

const LoggedInAdminData = ({ onHide }: LoggedInAdminDataProps) => {

	const { user } = useUser();
	const [isLoading, setIsLoading] = useState(false);

	const formatDate = (dateString: moment.MomentInput) => {
		return moment(dateString).format('DD-MM-YYYY');
	};

	return (
		<>
			<div className="modal-backdrop" onClick={onHide}></div>
			<div className="modal-container">
				<div className="book-details-body">
					<div className="custom-modal-header">
						<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
							<img src={backBtn} alt="back" onClick={onHide} style={{ cursor: 'pointer' }} />
							<h4>Admin Details</h4>
						</div>
						{/* <Button className="edit-user-status">Edit</Button> */}
					</div>
					{isLoading ? (
						<div className="spinner-div">
							<Spinner animation="border" size="sm" role="status" />
						</div>
					) : (
						<div className="custom-modal-body">
							<div className="detail-section">
								<div className="book-detail">
									<span>First Name</span>
									<p>{user ? user.firstName : 'name'}</p>
								</div>
								<div className="book-detail">
									<span>Last Name</span>
									<p>{user.lastName}</p>
								</div>
								<div className="book-detail">
									<span>Email</span>
									<p>{user.email}</p>
								</div>
								<div className="book-detail">
									<span>Type</span>
									<p>{user.type}</p>
								</div>
								<div className="book-detail">
									<span>Role</span>
									<p>{user.role}</p>
								</div>
							</div>
							<div className="detail-section">
								<div className="book-detail">
									<span>Date Joined</span>
									<p>{formatDate(user.createdAt)}</p>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	)
}

export default LoggedInAdminData;